import React from "react";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import {
  ALL_POSITIONS_OPTION,
  applyAllPositionsSentinel,
  knownPositionKeys,
  positionOptions,
  showProfileControl,
} from "../utils/selectedProfile";

// Position filter for the provider dashboards; shown only to users with two or more labelled positions
const PositionFilter = ({ rows, selectedKeys, onChange }) => {
  if (!showProfileControl(rows)) return null;

  const options = positionOptions(rows);
  const keys = knownPositionKeys(rows, selectedKeys);
  const value = keys.length > 0 ? options.filter((option) => keys.includes(option.id)) : [ALL_POSITIONS_OPTION];

  const handleChange = (event) => {
    const { keys: nextKeys } = applyAllPositionsSentinel(value, event.value);
    onChange(nextKeys);
  };

  return (
    <div className="position-filter" style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <label>Position</label>
      <MultiSelect
        data={[ALL_POSITIONS_OPTION, ...options]}
        textField="text"
        dataItemKey="id"
        value={value}
        autoClose={false}
        onChange={handleChange}
        style={{ width: 260 }}
      />
    </div>
  );
};

export default PositionFilter;
